/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconEyeClosed = createReactComponent("outline", "eye-closed", "IconEyeClosed", [["path", { "d": "M21 9c-2.4 2.667 -5.4 4 -9 4c-3.6 0 -6.6 -1.333 -9 -4", "key": "svg-0" }], ["path", { "d": "M3 15l2.5 -3.8", "key": "svg-1" }], ["path", { "d": "M21 14.976l-2.492 -3.776", "key": "svg-2" }], ["path", { "d": "M9 17l.5 -4", "key": "svg-3" }], ["path", { "d": "M15 17l-.5 -4", "key": "svg-4" }]]);

export { IconEyeClosed as default };
//# sourceMappingURL=IconEyeClosed.mjs.map
